import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useAuth } from '../lib/auth';
import { productScreen, setProductMeasurement, trackProductScreen } from '../lib/analytics';

/** Lives below AuthProvider so staff and impersonation traffic are excluded. */
export function ProductAnalytics() {
  const { pathname } = useLocation();
  const { user, status, isAdmin, isImpersonating } = useAuth();
  useEffect(() => {
    const publicScreen = pathname === '/signup' || pathname === '/login';
    const active = status !== 'loading' && status !== 'error' && !isAdmin && !isImpersonating
      && !!productScreen(pathname) && (!!user || publicScreen);
    setProductMeasurement(active);
    if (active) trackProductScreen(pathname, !!user);
  }, [pathname, status, isAdmin, isImpersonating, user?.id]);
  return null;
}
